import React from 'react'
import PropTypes from 'prop-types'

import V1 from './template/v1/V1'
import V2 from './template/v2/V2'
import { FooterProvider } from './FooterContext'

const Footer = ({
  template = 'v1',
  themeColor = 'dark',
  lang = 'en',
  intl = {},
  isMinimal = false,
  enableTracking = false,
  pageOrScreen,
  isUnbranded = false,
  disableAllTargetBlank = false,
  useMobileFooter = false,
  ...rest
}) => {
  const providerProps = {
    themeColor,
    lang,
    intl,
    isMinimal,
    enableTracking,
    pageOrScreen,
    position: 'footer',
    isUnbranded,
    disableAllTargetBlank,
    useMobileFooter,
  }

  switch (template) {
    case 'v1':
      return <V1 {...providerProps} {...rest} />
    case 'v2':
      return (
        <FooterProvider {...providerProps}>
          <V2 {...rest} />
        </FooterProvider>
      )
    default:
      return <V1 {...providerProps} {...rest} />
  }
}

Footer.propTypes = {
  template: PropTypes.string,
  themeColor: PropTypes.string,
  lang: PropTypes.string,
  intl: PropTypes.shape({
    changeLocale: PropTypes.func,
    languageList: PropTypes.object,
  }),
  isMinimal: PropTypes.bool,
  enableTracking: PropTypes.bool,
  pageOrScreen: PropTypes.string,
  disableAllTargetBlank: PropTypes.bool,
}

export default Footer
